import { Injectable } from '@angular/core';
import { StarbaseDataService } from 'starbase-launcher';
import { BoundImageSet } from '../models/boundImageSet';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class BoundSetService extends StarbaseDataService<BoundImageSet> {
  protected _staleDataTimeout = 2000;
  protected _getOneUri: string;
  protected _getAllUri = '/api/BoundImageSetModels';
  protected _postUri = '/api/BoundImageSetModels';
  protected _putUri = '/api/BoundImageSetModels/';
  protected _deleteUri = '/api/BoundImageSetModels/DeleteBoundImageSetModel';
  protected _broadSearchUri = '/api/BoundImageSetModels/GetBoundSetsBroadSearch';

  constructor(private _http: HttpClient, private _webApiSvc: WebApiService) {
    super(_http, _webApiSvc);
  }

}
